export enum AcknowledgementType {
  MatchesWereAlmostGone = 'MatchesWereAlmostGone',
  EndOfPremium = 'EndOfPremium',
  FirstTimeExperience = 'FirstTimeExperience',
  InsiderNetworkFirstTimeExperience = 'InsiderNetworkFirstTimeExperience',
  EmailConnectionError = 'EmailConnectionError',
  CampaignError = 'CampaignError',
}
